import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

export default {
  routes: [
    {
      name: "expenses",
      path: "expenses/:filter?",
      meta: {
        auth: () =>
          store.getters.isAdmin() || store.getters.hasRole("accounting"),
        icon: "expense",
        title: i18n.global.tc("Expense", 100),
        crumbs: ["accounting"],
        color: "primary",
      },
      component: () => import("../../../pages/employee/Expenses"),
    },
  ],

  dialogs: [],
};
